import { generateLogoutUrl } from '@utils/loginUtil'
import { errorWithStack } from '@utils/logger'

export const logoutUser = async ({ env }) => {
  try {
    const response = await fetch(generateLogoutUrl(env), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      credentials: 'include',
    })

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    errorWithStack('Logout failed:', error)
    throw error
  }
}
